import styles from "./Input.module.css";

interface TextInputProps {
  placeholder: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  type?: string;
  disable?: boolean;
}

const TextInput: React.FC<TextInputProps> = ({
  placeholder,
  value,
  onChange,
  type = "text",
  disable = false,
}) => {
  return (
    <input
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      className={styles.singleInput}
      disabled={disable}
    />
  );
};

export default TextInput;
